import { render, staticRenderFns } from "./couponTable.vue?vue&type=template&id=e3c0f0ec&scoped=true"
import script from "./couponTable.vue?vue&type=script&lang=js"
export * from "./couponTable.vue?vue&type=script&lang=js"
import style0 from "./couponTable.vue?vue&type=style&index=0&id=e3c0f0ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c0f0ec",
  null
  
)

export default component.exports